<template>
  <v-dialog
  v-model="reporteFechas.status"
  persistent
  max-width="1000"
  >
  <v-card>
    <v-card-title primary-title class="text-subtitle-1">
      Reporte egresos por Fecha
    </v-card-title>
    <v-card-text >

      	<v-row>
          <v-col cols="12" md="12" lg="12" class="pb-0">
            <div style="width: fit-content;">
              <label>Selecciona un ciclo</label>
              <v-autocomplete
                label="Ciclo"
                id="id"
                filled
                dense
                single-line
                hide-details
                v-model="ciclo"
                :items="ciclos"
                item-text="ciclo"
                item-value="ciclo"
                clearable
              ></v-autocomplete>
            </div>
          </v-col>

      		<v-col cols="12" md="6" lg="4">
		        <v-text-field
		          v-model="fechaini"
		          dense
		          filled
		          type="date"
		          label="Fecha inicio"
		          clearable
		        ></v-text-field>
      		</v-col>

      		<v-col cols="12" md="6" lg="4">
		        <v-text-field
		          v-model="fechafin"
		          dense
		          filled
		          type="date"
		          label="Fecha final"
		          clearable
		        ></v-text-field>
      		</v-col>
      		<v-col cols="12" md="6" lg="4">
      			<v-btn
              color="orange"
              dark
              @click="initialize"
              small
              tile
            >
              <v-icon small>mdi-refresh</v-icon>
            </v-btn>
            <v-btn
              class="ml-2"
              small dark color="green"
              @click="exportExcel(reporte, 'reporte-egresos-por-fecha')"
              tile
            >
              <v-icon small>mdi-microsoft-excel</v-icon>
            </v-btn>
      		</v-col>
      	</v-row>

        <v-data-table
          :headers="headersReporte"
          :items="reporte"
          class="elevation-0"
          dense
          :search="search"
        >
          <template v-slot:item.avance="{ item }">
            {{ item.avance }}%
          </template>
        </v-data-table>
      </v-card-text>
    <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
        	color="black"
        	dark
        	tile
        	@click="cerrar()"
        >Cancelar</v-btn>
      </v-card-actions>
  </v-card>

  <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>
  </v-dialog>
</template>

<script>

  // Componentes
  import Alerta               from '@/components/alertas/Alerta.vue';
  import carga                from '@/components/alertas/carga.vue';

  import validarErrores      from '@/mixins/validarErrores';
  import funcionesExcel      from '@/mixins/funcionesExcel';

  export default {

    components:{
      Alerta,
      carga,
    },

    mixins: [ validarErrores, funcionesExcel ],

    props: [
      'reporteFechas',
      'ciclos'
    ],

    data: () => ({

      // Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,


      search: '',
      fechaini: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
		  fechafin: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      headersReporte: [
        { text: "Usuario"      , value: "usuario_autorizo_rechazo_nombre_completo" },
        { text: "Con Comprobante"      , value: "con_comprobante" },
        { text: "Sin Comprobante"      , value: "sin_comprobante" },
        { text: "Autorizado"      , value: "autorizado" },
        { text: "Rechazado"      , value: "rechazado" },
        { text: "Avance"      , value: "avance" },
        { text: "Total"      , value: "total" },
      ],
      nomina: [],
      reporte: [],
      reporteAux: [],
      ciclo: null,

    }),

    created(){
      this.initialize()
    },

    methods: {
      initialize(){

        let payload = {
          fecha_inicio: this.fechaini,
          fecha_final: this.fechafin,
          ciclo: this.ciclo
        }

        this.cargar = true;
        this.reporte = []

        this.$http.post("consultar.partidas.egreso", payload)
        .then((response) => {
          this.nomina = response.data;
          this.reporteAux = response.data;

          // Separar por usuarios
          const listaUnicos = [
            ...new Set(this.reporteAux.map(item => item.usuario_autorizo_rechazo_nombre_completo))
          ];

          listaUnicos.map(nombre_completo => {

            const totalComprobantes = this.reporteAux.filter(objeto1 => objeto1.estatus == "Con Comprobante" &&objeto1.usuario_autorizo_rechazo_nombre_completo === nombre_completo).length;
            const totalSinComprobantes = this.reporteAux.filter(objeto1 => objeto1.estatus == "Sin Comprobante" && objeto1.usuario_autorizo_rechazo_nombre_completo === nombre_completo).length;
            const totalRechazado = this.reporteAux.filter(objeto1 => objeto1.estatus == "Rechazado" && objeto1.usuario_autorizo_rechazo_nombre_completo === nombre_completo).length;
            const totalAutorizado = this.reporteAux.filter(objeto1 => objeto1.estatus == "Autorizado" && objeto1.usuario_autorizo_rechazo_nombre_completo === nombre_completo).length;

            this.reporte.push({
              usuario_autorizo_rechazo_nombre_completo: nombre_completo,
              con_comprobante: totalComprobantes,
              sin_comprobante: totalSinComprobantes,
              autorizado: totalAutorizado,
              rechazado: totalRechazado,
              avance: ( ( totalAutorizado / ( totalComprobantes + totalSinComprobantes + totalAutorizado + totalRechazado ) ) * 100 ).toFixed(1),
              total: totalComprobantes || 0 + totalSinComprobantes || 0 + totalAutorizado || 0 + totalRechazado || 0
            })
          })

        })
        .catch((error) => {
          this.validarError(error);
        })
        .finally(() => {
          this.dialogEgresos = true
          this.cargar = false;
        });

    },
    exportar( ){
      this.exportExcel( this.reporte  , 'reportePagosPorFecha')
    },
    cerrar(){
      this.fechaini = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
      this.fechafin = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
      this.reporte = []
      this.nomina = []
      this.reporte = []
      this.reporteAux = []
      this.ciclo = null
      this.initialize()
      this.reporteFechas.status = false
    },
    }

  }

</script>

<style scoped>

</style>
